import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { DIRECTIONS } from 'constants'

import styles from './StartingPoint.scss'

const StartingPoint = ({ children, direction }) => {
    return (
        <div className={styles.base}>
            {children.map((component, idx) => {
                return (
                    <div
                        key={idx}
                        className={cx(
                            styles.placeholder,
                            direction && styles[`placeholder__${direction}${idx + 1}`]
                        )}
                    >
                        <div className={styles.inner}>{component}</div>
                    </div>
                )
            })}
        </div>
    )
}

StartingPoint.propTypes = {
    direction: PropTypes.oneOf(DIRECTIONS),
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
}

export default StartingPoint



// WEBPACK FOOTER //
// ./components/StartingPoint/StartingPoint.jsx